<!-- eslint-disable -->
<template>
    <el-container>
        <el-row class="list-container">
            <el-col :span="24">
                <el-button @click="refreshData" type="primary" size="small" icon="iconfont icon-shuaxin shuaxin">刷新</el-button>
                <el-button @click="clearAll" type="danger" size="small" icon="iconfont icon-shanchu shuaxin" :disabled="!power.login_log_clear">清空</el-button>
            </el-col>

            <!-- search start  -->
            <!-- <el-col :span="24" class="search-content">
                <div class="search-item" style="width: 130px;">
                    <el-select v-model="data.searchSelect" placeholder="请选择titleSelect" size="small">
                        <el-option
                            v-for="item in [{id: 1, name: 'test_select'}]"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="search-item">
                    <el-input v-model="data.searchText" size="small" placeholder="请输入textContent" clearable></el-input>
                </div>
                <div class="search-item">
                    <el-button size="small" icon="iconfont icon-fangdajing shuaxin" @click="search">搜索</el-button>
                </div>
            </el-col> -->
            <!-- search end  -->

            <el-col class="main-content">
                <el-table :data="dataList" border v-loading="loading" style="width: 100%">
                    <el-table-column prop="id" label="ID" width="80"></el-table-column>

                    <el-table-column prop="username" label="账号" width="180"></el-table-column>
                    <el-table-column prop="name" label="姓名" width="180"></el-table-column>
                    <el-table-column prop="roles_name" label="角色" width="180"></el-table-column>
                    <el-table-column prop="ip" label="登录IP" width="180"></el-table-column>
                    <el-table-column prop="created_at" label="登录时间"></el-table-column>
                    <!-- <el-table-column label="操作" min-width="180">
                        <template slot-scope="scope">
                            <el-button @click="editTmp(scope.row)" icon="iconfont icon-bianji shuaxin" type="primary" size="mini" plain>编辑</el-button>
                            <el-button @click="del(scope.row.id)" icon="iconfont icon-shanchu shuaxin" size="mini" type="danger" plain>删除</el-button>
                        </template>
                    </el-table-column> -->
                </el-table>
            </el-col>
            <el-col class="pagination">
                <el-pagination
                    @current-change="changePage"
                    @size-change="changePageSize"
                    background
                    :layout="pageLayout"
                    :page-sizes="pagePageSizes"
                    :page-size="pagePageSize"
                    :total="totalCount"
                    :current-page.sync="current_page"
                    :hide-on-single-page="false">
                </el-pagination>
            </el-col>
        </el-row>

    </el-container>
</template>

<!-- eslint-disable -->
<script>
    import {LoginLogIndex, LoginLogClear} from "@/utils/request.js"
    import {mapState} from 'vuex'

    export default {
        data(){
            return {
                data: {
                    page: 1,
                    page_size: this.pagePageSize,
                    searchSelect: '',
                    searchText: '',
                },
                loading: false,
                dataList: [],
                totalCount: 0,
                current_page: 1,
            }
        },
        created() {
            this.getList()
        },
        computed: mapState(['power']),
        methods: {
            search() {
                this.data.page = 1
                this.current_page = 1
                this.getList()
            },
            refreshData() {
                this.data.page = 1
                this.current_page = 1
                this.loading = true

                this.getList()
            },
            getList() {
                this.loading = true
                LoginLogIndex(this.data).then((res) => {
                    if (res.code == 200) {
                        this.data.page++
                        this.dataList = res.data.data
                        this.totalCount = res.data.count
                    } else {
                        this.$message.error("数据获取失败!")
                    }
                    this.loading = false
                })
            },
            changePage(page) {
                this.data.page = page
                this.getList()
            },
            changePageSize(size) {
                this.data.page_size = size
                this.data.page = 1
                this.current_page = 1
                this.getList()
            },
            clearAll() {
              this.$confirm('确定要清空日志吗?', '提示', {
              	confirmButtonText: '确定',
              	cancelButtonText: '取消',
              	type: 'error'
              }).then(() => {
              	LoginLogClear(this.data).then((res) => {
              	    if (res.code == 200) {
              	        this.data.page = 1
              	        this.getList()
                        this.$message.success(res.msg);
              	    } else {
              	        this.$message.error("清空失败!")
              	    }
              	})
              }).catch(() => {
              	// 取消操作
              });
            }
        }
    }
</script>

<style>
</style>
